export interface Venda extends VendaMedidas {
  codigo: number;
  nome: string;
  sigla?: string;
}

export function convertVendaCombustivelToVenda(item: VendaCombustivel): Venda {
  return {
    codigo: item.produtoCod,
    nome: item.produtoNome,
    sigla: item.sigla,
    ...item
  };
}

export function convertVendaProdutoToVenda(item: VendaProduto): Venda {
  return {
    codigo: item.produtoCod,
    nome: item.produtoNome,
    ...item
  };
}

export function convertVendaGrupoProdutoToVenda(item: VendaGrupoProduto): Venda {
  return {
    codigo: item.grupoCod,
    nome: item.grupoNome,
    ...item
  };
}

export function convertVendaVendedorToVenda(item: VendaVendedor): Venda {
  return {
    codigo: item.vendedorCod,
    nome: item.vendedorNome,
    ...item
  };
}

export interface VendaCombustivel extends VendaMedidas {
  produtoCod: number;
  produtoNome: string;
  sigla?: string;
}

export interface VendaProduto extends VendaMedidas {
  produtoCod: number;
  produtoNome: string;
}

export interface VendaGrupoProduto extends VendaMedidas {
  grupoCod: number;
  grupoNome: string;
}

export interface VendaVendedor extends VendaMedidas {
  vendedorCod: number;
  vendedorNome: string;
}

export interface VendaMedidas extends Record<string, any> {
  quantidade: number;
  totalLiquido: number;
  total: number;
  contagem: number;
  mediaLiquida: number;
  mediaQuantidade: number;
  mediaPreco: number;
  desconto: number;
  acrescimo: number;
  custo: number;
  custoMedio: number;
  lucroBruto: number;
  lucroBrutoMedio: number;
  margemLucroMedia: number;
  margemCustoMedia: number;
  custoMedioUnitario: number;
  lucroBrutoMedioUnitario: number;
}

export interface VendaBico {
  bico: number;
  produtoNome: string;
  quantidade: number;
  total: number;
  contagem: number;
  menorEncerrante?: number;
  maiorEncerrante?: number;
}

export interface VendaForma {
  formaNome: string;
  total: number;
  contagem: number;
}